import { Link } from 'react-router-dom';
import Logo from './Logo';
import { SITE_NAME, SITE_TAGLINE } from '../config/site';

/**
 * Footer for logged-out visitors.
 */
function UnauthenticatedFooter() {
  return (
    <footer className="bg-navy py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <Logo size={32} />
          <span className="text-lg font-semibold text-white">{SITE_NAME}</span>
        </div>
        <p className="text-sm text-gray-400 mb-4">{SITE_TAGLINE}</p>

        <ul className="flex justify-center gap-x-6 gap-y-2 flex-wrap">
          <li>
            <Link to="/leaderboard" className="text-sm text-gray-400 hover:text-white transition-colors">
              Leaderboard
            </Link>
          </li>
          <li>
            <Link to="/login" className="text-sm text-gray-400 hover:text-white transition-colors">
              Login
            </Link>
          </li>
          <li>
            <Link to="/register" className="text-sm text-gray-400 hover:text-white transition-colors">
              Sign Up
            </Link>
          </li>
        </ul>

        <div className="mt-8 pt-6 border-t border-gray-800">
          <p className="text-sm text-gray-500">
            &copy;
            {' '}
            {new Date().getFullYear()}
            {' '}
            {SITE_NAME}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default UnauthenticatedFooter;
